/* eslint-disable max-len */
export const isLoggedIn = state => state.isLoggedIn && state.accessToken;
export const addresses = state => state.addresses;
export const items = state => state.items;
export const getPaymentMethod = state => id => state.paymentMethods.find(method => method.id === id);
export const getDefaultCardNumber = state => state.paymentMethods.find(method => method.isDefault === 0);
